import { Meal } from '@tovala/browser-apis-combinedapi'
import { ReactNode, useRef } from 'react'

import MealDetailsDialog from 'components/common/details/MealDetailsDialog'
import { trackDetailsSectionOpened } from 'components/common/details/shared'

import { MealRating } from './hooks'
import MealDetailsAverageRating from './MealDetailsAverageRating'
import MealRatingBadge from './MealRatingBadge'
import MealReviews from './MealReviews'

const MenuMealDetailsDialog = ({
  averageStars,
  closeModal,
  meal,
  orderStatus,
  price,
  rating,
  shouldScrollToReview,
  stepper,
}: {
  averageStars: number | undefined
  closeModal(): void
  meal: Meal
  orderStatus?: ReactNode
  price?: ReactNode
  rating: MealRating | undefined
  shouldScrollToReview: boolean
  stepper?: ReactNode
}) => {
  const reviewsTriggerRef = useRef<HTMLButtonElement>(null)

  return (
    <MealDetailsDialog
      averageRating={
        averageStars === undefined ? undefined : (
          <MealDetailsAverageRating
            onClick={() => {
              openAndScrollToReviews(reviewsTriggerRef.current)
            }}
            stars={averageStars}
          />
        )
      }
      closeModal={closeModal}
      imageTag={rating ? <MealRatingBadge stars={rating.stars} /> : undefined}
      meal={meal}
      orderStatus={orderStatus}
      price={price}
      reviews={
        <MealReviews
          mealID={meal.id}
          rating={rating}
          shouldScrollToReview={shouldScrollToReview}
          triggerRef={reviewsTriggerRef}
        />
      }
      stepper={stepper}
    />
  )
}

export default MenuMealDetailsDialog

function openAndScrollToReviews(trigger: HTMLButtonElement | null) {
  if (trigger?.getAttribute('aria-expanded') === 'false') {
    trigger.click()
    trackDetailsSectionOpened('reviews')
  }

  trigger?.scrollIntoView({ behavior: 'smooth', block: 'start' })
}
